import URL from 'url';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import queryString from 'query-string';
import { Actions } from 'react-native-router-flux';
import GenericModule from '../../Native/GenericModule';
import { navigation } from '@mmt/navigation';

export const canOpenReactPage = (deepLinkObj) => {
  // TODO THIS CONDITION NEED TO MAKE MORE GENERIC SPECIALLY FOR HOST
  if (
    deepLinkObj &&
    deepLinkObj.protocol === 'mmyt:' &&
    (deepLinkObj.host === 'react' ||
      deepLinkObj.host === 'wallet' ||
      deepLinkObj.host === 'events' ||
      deepLinkObj.host === 'rewards')
  ) {
    const queryDict = getQueryDict(deepLinkObj);
    if (queryDict && queryDict.page) {
      return queryDict;
    }
    return null;
  }
  return null;
};

export const getQueryDictFromString = (deeplink) => {
  const url = URL.parse(deeplink);
  if (url && url.query) {
    return queryString.parse(url.query);
  }
  return null;
};

export const getQueryDict = (deepLinkObj) => {
  if (deepLinkObj && deepLinkObj.query) {
    return queryString.parse(deepLinkObj.query);
  }
  return null;
};

export const openReactPage = (queryDict) => {
  if (!queryDict || !queryDict.page) {
    return;
  }
  const params = {};
  map(queryDict, (value, key) => {
    params[key] = value;
  });
  Actions[queryDict.page](params);
};

export const handleDeeplink = (deeplink) => {
  const reactProps = canOpenReactPage(URL.parse(deeplink));
  if (reactProps) {
    openReactPage(reactProps);
  } else {
    GenericModule.openDeepLink(deeplink);
  }
};

export const handleNavigationDeeplink = (deeplink) => {
  const queryDict = getQueryDict(URL.parse(deeplink));
  const isHandled = navigateReactPage(queryDict);
  if (!isHandled) {
    GenericModule.openDeepLink(deeplink);
  }
};

export const navigateReactPage = (queryDict) => {
  if (!isEmpty(queryDict?.page)) {
    const params = {};
    map(queryDict, (value, key) => {
      params[key] = value;
    });
    navigation.navigate(queryDict.page, params);
    return true;
  }
  return false;
};
